var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8019 20.7027L19.6571 17.0418C18.8912 15.7343 17.0204 15.6888 16.2538 16.9282C15.6991 17.7801 14.527 18.0277 13.6481 17.5766C11.71 16.5168 9.61477 13.0903 9.66498 10.7778C9.59764 9.76344 10.4904 8.88916 11.5047 8.82186C12.9607 8.75914 13.8357 7.10501 13.0697 5.79753L10.925 2.13661C10.2851 1.1943 9.04105 0.869405 8.12582 1.40559L5.64162 2.86095C3.13035 4.41998 3.87251 10.4832 7.47261 16.6283C11.0727 22.7734 15.9717 26.4892 18.5867 24.9572L21.0709 23.5019C22.0132 22.862 22.3381 21.618 21.8019 20.7027Z",
    fill: "#737B7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalPhone);
export default __webpack_public_path__ + "static/media/modal-phone.9b88ac50d8cb8a886205b0a017a0d3b0.svg";
export { ForwardRef as ReactComponent };